import { ISelectFieldOption } from "@/app/fields/types";
import { Stack, Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { Tooltip } from "react-tooltip";

export const MultiValues = ({
  options,
  onRemove,
  size = "lg",
  limit,
}: {
  options: ISelectFieldOption[];
  size?: "sm" | "md" | "lg";
  limit?: number;
  onRemove?: (value: string) => void;
}) => {
  const nbToDisplay = limit || options.length;
  return (
    <Stack direction="row" wrap="wrap" spacing={1}>
      {options.slice(0, nbToDisplay).map(({ value, label, group }) => (
        <Tag
          data-tooltip-id="my-tooltip"
          data-tooltip-content={getDisplayValue({ group, label })}
          size={size}
          data-cy={`multi-field-badge-${value}`}
          key={String(value)}
        >
          <TagLabel className="break-all">
            {getDisplayValue({ group, label })}
          </TagLabel>
          {!!onRemove && (
            <TagCloseButton
              data-cy={`multivalue-close-button-${value}`}
              onClick={() => onRemove(value)}
            />
          )}
        </Tag>
      ))}
      {nbToDisplay < options.length && (
        <Tag data-cy={`multi-field-badge-overflow`} size={size}>
          +{options.length - nbToDisplay}
        </Tag>
      )}
      <Tooltip id="my-tooltip" className="z-50" />
    </Stack>
  );
};

export const getDisplayValue = ({
  group,
  label,
}: Omit<ISelectFieldOption, "value">) => {
  if (!group) {
    return label;
  }
  return `${group} › ${label}`;
};
